<template>
    <vx-card title="Security">
      <a-form :form="form" @submit.prevent="handleSubmitSecurity">
        <a-form-item label="Current Password" has-feedback>
          <a-input-password
            class="w-full md:w-1/2"
            v-decorator="['old_password',{ initialValue: null,rules: [{ required: true,message:'This field is required.' }] }]"
          />
        </a-form-item>
        <a-form-item label="New Password" has-feedback>
          <a-input-password
            class="w-full md:w-1/2"
            v-decorator="['new_password',{ initialValue: null,rules: [{ required: true,message:'This field is required.' },{validator: validateToNextPassword }] }]"
          />
        </a-form-item>
        <a-form-item label="Confirm New Password" has-feedback>
          <a-input-password
            class="w-full md:w-1/2"
            v-decorator="['confirm_new_password',{ initialValue: null,rules: [{ required: true,message:'This field is required.' },{validator: compareToFirstPassword}]}]"
            @blur="handleConfirmBlur"
          />
        </a-form-item>
        <div class="flex items-center mt-5">
          <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
            Update Password
          </a-button>
          <div class="pl-2">or</div>
          <a-button type="link" @click="$emit('changeTab','UserSettingsGeneral')">
            Cancel
          </a-button>
        </div>
      </a-form>
<!--      <a-tabs default-active-key="1">-->
<!--        <a-tab-pane key="1" tab="Update Password">-->
<!--  -->
<!--        </a-tab-pane>-->
<!--        <a-tab-pane key="2" tab="Two-Factor Setup">-->
<!--          <h4>Set up Google two-factor authentication</h4>-->
<!--          <p class="font-medium w-2/3 text-justify">-->
<!--            Google Authenticator generates 2-factor verification codes on your phone. Enable-->
<!--            2-factor verification to protect your account from hijacking by adding another layer-->
<!--            of security. With 2-factor verification, signing in will require a code generated by-->
<!--            the Google Authenticator app in addition to your account password.-->
<!--            Please note: Clio customers with enabled 2-factor verification will not be required-->
<!--            to verify their password and secondary authentication code when setting up-->
<!--            Desktop Outlook sync.-->
<!--          </p>-->
<!--          <a-form-item>-->
<!--            <a-checkbox>-->
<!--             <small class="font-medium">Enable Google Two-factor authentication</small>-->
<!--            </a-checkbox>-->
<!--          </a-form-item>-->
<!--          <a-button type="primary" size="large" class="mt-5" style="border-radius: 3px !important;">-->
<!--            Update Two-factor Setting-->
<!--          </a-button>-->
<!--        </a-tab-pane>-->
<!--        <a-tab-pane key="3" tab="Sessions" forceRender>-->
<!--          <XTable :model="model" v-if="false">-->
<!--            <span slot="names">-->
<!--              samuel-->
<!--            </span>-->
<!--            <span slot="ip">-->
<!--              89.46.102.525-->
<!--            </span>-->
<!--            <span slot="last-active">-->
<!--              Last than a minute-->
<!--            </span>-->
<!--            <span slot="active">-->
<!--                10 minutes-->
<!--            </span>-->
<!--          </XTable>-->
<!--        </a-tab-pane>-->
<!--        <a-tab-pane key="4" tab="Password Security">-->
<!--          <div class="pl-10 pt-5">-->
<!--            <h4>Strong Passwords</h4>-->
<!--            <p class="w-2/3 font-medium">-->
<!--              Requiring strong passwords adds an additional level of security to your Clio-->
<!--              account. Once enabled, all users will receive an email to strengthen their-->
<!--              passwords.-->
<!--            </p>-->
<!--            <p class="w-2/3 font-medium">-->
<!--              For more information, you can read our support article on using Clio's password-->
<!--              security feature.-->
<!--            </p>-->
<!--            <a-form-item>-->
<!--              <a-checkbox>-->
<!--                <small class="font-medium">Require strong passwords</small>-->
<!--              </a-checkbox>-->
<!--            </a-form-item>-->
<!--            <h4>Password Expiry</h4>-->
<!--            <p>User passwords will expire every</p>-->
<!--            <a-select-->
<!--              placeholder="Never exprires/30days/100days ..."-->
<!--              allowClear-->
<!--              class="w-1/2 select"-->
<!--              v-decorator="['task',{ rules: [{ required: false, message: '' }] }]"-->
<!--            >-->
<!--              <a-select-option value="1">-->
<!--                exprires 1-->
<!--              </a-select-option>-->
<!--              <a-select-option value="2">-->
<!--                exprires 2-->
<!--              </a-select-option>-->
<!--              <a-select-option value="3">-->
<!--                exprires 3-->
<!--              </a-select-option>-->
<!--            </a-select>-->
<!--            <p class="pt-5 text-xs">Users will be reminded 14 days before passwords expire</p>-->
<!--            <a-button type="primary" size="large" class="mt-5 rounded-sm">-->
<!--              Update Two-factor Setting-->
<!--            </a-button>-->
<!--          </div>-->
<!--        </a-tab-pane>-->
<!--        <a-tab-pane key="5" tab="Firm Security" forceRender>-->
<!--          <div class="pl-10 pt-5">-->
<!--            <h4 class="font-semibold">Firm Security</h4>-->
<!--            <p class="w-2/3 font-medium text-justify">-->
<!--              Requiring two-factor authentication (2FA) at your firm allows firm members to use a security code in-->
<!--              addition to their password to sign in to Clio applications.-->
<!--            </p>-->
<!--            <p class="w-2/3 font-medium text-justify">-->
<!--              This additional layer of security is strongly recommended.  about two-factor authentication-->
<!--            </p>-->
<!--          </div>-->
<!--          <XTable :model="modelSecurity" v-if="false"></XTable>-->
<!--        </a-tab-pane>-->
<!--      </a-tabs>-->
    </vx-card>
</template>

<script>
    import * as TableColSeesion from "./seesionTbl";
    import * as TableColFirmSec from "./firmsecurity";
    import XTable from "../../../../components/x-table/XTable";
    import mixin from '../../../mixin/mixin'
    import axios from "@/axios";

    export default {
        name: "Security",
        mixins:[mixin],
        components:{
          XTable
        },
        data(){
          return{
            model:null,
            modelSecurity:null,
            confirmDirty:false
          }
        },
        methods:{
          handleConfirmBlur(e) {
            const value = e.target.value;
            this.confirmDirty = this.confirmDirty || !!value;
          },
          validateToNextPassword(rule, value, callback) {
            const form = this.form;
            if (value && this.confirmDirty) {
              form.validateFields(['confirm_password'], { force: true });
            }
            callback();
          },
          compareToFirstPassword(rule, value, callback) {
            const form = this.form;
            if (value && value !== form.getFieldValue('new_password')) {
              callback('Two passwords that you enter is inconsistent!');
            } else {
              callback();
            }
          },
          handleSubmitSecurity(){
            this.form.validateFields(async(err,values)=>{
              if(!err){
                try{
                  this.$vs.loading()
                  values.confirm_new_password = undefined
                  await axios.post('/account/change-password/', values)
                  this.$notification['success']({
                    message: 'Success',
                    description: `Security success.`,
                  });
                  this.$emit('changeTab','UserSettingsGeneral')
                }catch (e) {
                  this.$notification['error']({
                    message: 'failed',
                    description: `${e.data.message}`,
                  });
                }finally {
                  this.$vs.loading.close()
                }
              }
            })
          },
        },
        created() {
          this.model = TableColSeesion.default
          this.modelSecurity = TableColFirmSec.default
        }
    }
</script>

<style scoped>

</style>
